import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';
import { StoreInstagramMedia } from '../models';

export function useInstagramMedia() {
  const [media, setMedia] = useState<StoreInstagramMedia[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    storeService
      .getInstagramMedia()
      .then((data) => {
        if (active) setMedia(data);
      })
      .catch(() => {
        if (active) setMedia([]);
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { media, isLoading, isEmpty: media.length === 0 };
}
